import React from "react";
import useOrders from "../../hooks/useOrders";
import { useSelector } from "react-redux";
import { configurations } from "../../configurations";
import Icon from "../HOC/Icon";
import useAccount from "../../hooks/useAccount";

function OrderTypeSelection({ reload }) {
  const {
    ticketType,
    hotelTotal,
    tourTotal,
    insuranceTotal,
    packageTotal,
    esimTotal,
  } = useSelector((state) => state.order);
  const { getOrdersCount, selectOrderType } = useOrders();
  const { checkPermission } = useAccount();

  const ticketTypes = [];
  if (checkPermission("read:flight-booking"))
    ticketTypes.push({
      name: "Flights",
      count: getOrdersCount().flights,
      onClick: () => selectOrderType("Flights"),
    });

  const tabs = [
    {
      name: configurations.stayKeyword,
      count: hotelTotal,
      onClick: () => selectOrderType(configurations.stayKeyword),
    },
    {
      name: configurations.tourKeyword,
      count: tourTotal,
      onClick: () => selectOrderType(configurations.tourKeyword),
    },
    {
      name: configurations.insuranceKeyword,
      count: insuranceTotal,
      onClick: () => selectOrderType(configurations.insuranceKeyword),
    },
    {
      name: configurations.services.package.alias,
      count: packageTotal,
      value: configurations.services.package.value,
      onClick: () => selectOrderType(configurations.services.package.value),
    },
    {
      name: configurations.services.esim.alias,
      count: esimTotal,
      value: configurations.services.esim.value,
      onClick: () => selectOrderType(configurations.services.esim.value),
    },
  ];

  ticketTypes.push(...tabs);

  return (
    <div className="w-full flex flex-col pt-10">
      <span className="font-black text-xl mb-4 flex items-center gap-4">
        Orders
        <Icon
          icon="mdi:reload"
          className="cursor-pointer"
          size={20}
          onClick={() => reload && reload()}
        />
      </span>
      <div className="flex items-center gap-4 justify-between overflow-x-scroll scroll-hide w-full">
        <div className="flex items-center gap-4">
          {ticketTypes.map(({ name, count, value, onClick }) => {
            const selected = ticketType === value || ticketType === name;
            return (
              <button
                key={name}
                onClick={onClick}
                className={`h-14 flex items-center justify-between gap-2 px-4 font-bold rounded-lg ${
                  selected
                    ? "text-white bg-[#4E5662]"
                    : "text-[#818083] bg-[#F8F8F8]"
                }`}
              >
                <span className="text-xs md:text-base">{name}</span>
                <span
                  className={`text-sm px-2 rounded-md py-1 ${
                    selected ? "text-[#47A0FA] bg-[#5F6978]" : "bg-[#F1F1F1]"
                  }`}
                >
                  {count}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default OrderTypeSelection;
